module.exports = __webpack_public_path__ + "img/1791993828172.0b73436f.png";